import env from "./env";

/*
 * API_1 配置
 */
const API_1_CONF = {
    //dev: "https://dev.ccmapp.cn/preview/api-cms-production/cms/production/", // dev
    test: "https://dev.ccmapp.cn/preview/api-cms-production/cms/production/", // 测试环境
    // dev: "https://dev.ccmapp.cn/preview/api-cms-production/cms/production/", // 测试环境
    // production: "https://dev.ccmapp.cn/preview/api-cms-production/cms/production/", // 测试环境
    dev: "https://prod.ccmapp.cn/api-cms-production/cms/production/", // 线上环境
    production: "https://prod.ccmapp.cn/api-cms-production/cms/production/", // 线上环境
};

export const API_1 = API_1_CONF[env];
export const Global = {
    // conf2
    themelist: "apis/resource/dic/getbytype", //主题获取
    tourSum: "tour/tourSum", //多少人定制路线
    addTour: "tour/addTour", //新增旅游
    listTour: "tour/listTour", //旅游列表(所有)
    getTour: "tour/getTour", //查询旅游(单个)
    share: "tour/share", //分享
    shareVote: "tour/shareVote", //分享出去后的投票
    updateTourImage: "tour/updateTourImage", //保存旅游生成图片
    vote: "tour/vote", //投票
    // conf1
    draw: "prize/draw", //抽奖
    getPrizeNum: "prize/getPrizeNum", //获取抽奖次数
    list: "prize/list", //查询奖品列表
    listPrizeResult: "prize/listPrizeResult", //查询中奖纪录列表
    save: "prize/insertPrizeExchange", //兑换奖品信息--增
    ticketInfo: "prize/getPrizeTicketInfo",
    reviewInfo: "prize/getAlreadyPrizeTicketInfo" //券码-查看兑奖信息
};